import React from 'react';
import { Outlet } from 'react-router-dom';

interface ServiceItemPageInterface {}

const ServiceITemRootPage: React.FC<ServiceItemPageInterface> = () => <Outlet />;

export default ServiceITemRootPage;
